<template>
	<div class="yesNo"
		tabindex="0" 
		ref="root"
		v-on:keydown.esc="close"
		v-on:keydown="handleKey"
	>
		<div class='row'>
			<button v-for="(b,index) in buttons"
				v-on:click.stop="sendResponse(b)"
				class='row-child hover'
				:key='index'
				v-text="b"
			/>
			<div class='msg'>{{request}}</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'InstanceRequest',
		props: {
			request:{
				type: String,
				required: true,
			},
			buttons:{
				type:Array,
				required:true
			}
		},
		data(){
			return{
			}
		},
		mounted(){
			this.$nextTick(() => {
				const el = this.$refs.root
				if (el && typeof el.focus === 'function') {
					el.focus()
				}
			})
		},
		methods: {
			sendResponse(button){
				this.$emit('response',button)
			},
			handleKey(event){
				const key = (event.key || '').toUpperCase()
				const match = this.buttons.find(b => String(b).toUpperCase() === key)
				if (match) {
					event.preventDefault()
					this.sendResponse(match)
				}
			},
			close(){
				this.$emit('response',null)
			}
		},
	}
</script>

<style>

	.yesNo{
		position: relative;
	}

	button{
		align-items: center;
		border: 1px solid black;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		height: 24px;
		min-width: 17px;
		padding:0;
	}

	.hover:hover{
		cursor: pointer;
		background: #a6f4e5;
	}

	.row{
		white-space: nowrap;
		display: inline-flex;
	}

	.msg{
		font-weight: bold;
		background-color: #e3baba;
		display: inline-flex;
		position: relative;
		align-items: center;
		padding-left: 3px;
		padding-right: 3px;
		z-index: 100;
		border: 2px solid black;
		font-size: large;
	}

</style>